import Utils from "../services/utils-service.js";
import RTQ from "../services/rtq-service.js";
import Funnel from "../services/funnel-service.js";
import router from "../router.js";

export default {
    actions: {
        selectQuote(context, data) {
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType('pg_rtq');
            const $endpoint = `/api?req=${reqType}&action=process-selected-quote`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () { 
                    $fs.startPageLoading();
                },
                success: function (res) {
                    console.log('Selected Quote res: ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0) {
                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }
                    }
                    $fs.completePageLoading();
                },
                error: function () { }
            });
        },

        buyOnline(context, data) {
            console.log('buyOnline Post Data -: ', data);

            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType('pg_rtq');
            const $endpoint = `/api?req=${reqType}&action=process-qtb-bridge-quote`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () { },
                success: function (res) {
                    console.log('Buy Online Quote res: ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0) {
                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }

                        const buyRTQ = context.getters.funnel.elements['in_buy_online_rtq'];
                        if (!Utils.isObjEmpty(buyRTQ.data) && buyRTQ.data.QTB == 2) {
                            if (!Utils.isEmpty(res)) {
                                window.location = buyRTQ.data.quote_url;
                            }
                        } else if(!Utils.isObjEmpty(buyRTQ.data) && buyRTQ.data.QTB == 1) {
                            const qtbBaseRoute = context.getters.funnel.elements['pg_qtb_bridge'].page_route;
                            router.push(qtbBaseRoute).catch(() => { });
                        }

                    }
                },
                error: function () { }
            });
        }
    }
}